export const LOGIN = 'LOGIN'
export const LOGOUT_USER = 'LOGOUT'
export const VALIDATE_USER = 'VALIDATE_USER'
export const UPDATE_AUTH = 'UPDATE_AUTH'
export const REMOVE_ERROR = 'REMOVE_ERROR'
export const UPDATE_USER_AGREEMENT = 'UPDATE_USER_AGREEMENT'
export const REFRESH_TOKEN = 'REFRESH_TOKEN'
